// src/config/axiosConfig.js
import axios from 'axios';

// Configura la URL base
const axiosInstance = axios.create({
    baseURL: 'https://api-laravel.novedades-ramirez.com/api',
    //baseURL: 'http://192.168.0.106:8000/api',
});

export default axiosInstance;
